module.exports = __webpack_public_path__ + "img/1186.png";